/* Gornik & Drucker theme JS — vanilla port of mockup interactions. */
(function () {
  'use strict';

  /* Mobile nav drawer */
  var burger = document.querySelector('.nburger');
  var drawer = document.querySelector('.ndrawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      drawer.classList.toggle('on');
      burger.setAttribute('aria-expanded', drawer.classList.contains('on') ? 'true' : 'false');
    });
  }

  /* PDP accordions */
  document.querySelectorAll('.acc').forEach(function (acc) {
    var head = acc.querySelector('.acch');
    if (head) head.addEventListener('click', function () { acc.classList.toggle('open'); });
  });

  /* PDP gallery thumbs.
     Two kinds of thumb since 2026-10-08. An image thumb carries data-src and swaps the
     main <img>'s source, as before. A video thumb carries data-gvid and swaps which
     ELEMENT is visible, because a video cannot be loaded into an <img> src — that is the
     reason this needed a branch and not just a wider Liquid loop. Every video path below
     is a no-op on a product with no video, which is 28 of our 29. */
  var gmain = document.querySelector('.gmain');
  var gmainImg = gmain && gmain.querySelector('img.rimg');
  var gvids = gmain ? Array.prototype.slice.call(gmain.querySelectorAll('video[data-gvid]')) : [];

  document.querySelectorAll('.thumb').forEach(function (th) {
    th.addEventListener('click', function () {
      var vid = th.getAttribute('data-gvid');
      if (vid) {
        var target = null;
        gvids.forEach(function (v) { if (v.getAttribute('data-gvid') === vid) target = v; });
        if (!target) return;
        gvids.forEach(function (v) { if (v !== target) { v.pause(); v.style.display = 'none'; } });
        if (gmainImg) gmainImg.style.display = 'none';
        target.style.display = '';
        /* Autoplay can still be refused (data saver, some iOS states). The video is muted
           so it normally succeeds, and when it does not the poster and controls are both
           there, so the customer gets a playable video rather than a blank box. */
        var p = target.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        var src = th.getAttribute('data-src');
        if (!gmainImg || !src) return;
        gvids.forEach(function (v) { v.pause(); v.style.display = 'none'; });
        gmainImg.style.display = '';
        gmainImg.src = src;
        if (th.getAttribute('data-srcset')) gmainImg.srcset = th.getAttribute('data-srcset'); else gmainImg.removeAttribute('srcset');
      }
      document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('on'); });
      th.classList.add('on');
    });
  });

  /* PDP variant select -> keep the displayed price and the URL in sync.
     Without this the price is stuck on the first variant while the form submits
     whichever variant is chosen, so a $50 gift card can be bought at $250 with
     the page still reading $50. Each <option> carries its own formatted price. */
  var vsel = document.querySelector('select[name="id"]');
  var priceEls = document.querySelectorAll('[data-price]:not(option)');
  if (vsel) {
    vsel.addEventListener('change', function () {
      var opt = vsel.options[vsel.selectedIndex];
      if (!opt) return;
      var p = opt.getAttribute('data-price');
      if (p) priceEls.forEach(function (el) { el.textContent = p; });
      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* URL unsupported: price sync still works */ }
      }
    });
  }

  /* PDP sticky add-to-cart bar */
  var atcAnchor = document.querySelector('[data-atc-anchor]');
  var atcBar = document.querySelector('.atcbar');
  if (atcAnchor && atcBar) {
    var onScrollBar = function () {
      var show = atcAnchor.getBoundingClientRect().bottom < 0;
      atcBar.classList.toggle('on', show);
    };
    window.addEventListener('scroll', onScrollBar, { passive: true });
    var barBtn = atcBar.querySelector('[data-atc-proxy]');
    if (barBtn) barBtn.addEventListener('click', function () {
      var realBtn = document.querySelector('[data-atc-submit]');
      if (realBtn) realBtn.click();
    });
  }

  /* Collection filter pills (keyword match against product title) */
  var pillBar = document.querySelector('[data-filter-pills]');
  if (pillBar) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.colgrid [data-title]'));
    var matches = function (card, keys) {
      if (keys === 'all') return true;
      var title = (card.getAttribute('data-title') || '').toLowerCase();
      return keys.split(',').some(function (k) { return k.trim() && title.indexOf(k.trim()) !== -1; });
    };
    /* Hide pills that match nothing in this collection */
    var visiblePills = 0;
    pillBar.querySelectorAll('.pill').forEach(function (p) {
      var keys = (p.getAttribute('data-keys') || '').toLowerCase();
      var any = cards.some(function (c) { return matches(c, keys); });
      p.style.display = any ? '' : 'none';
      if (any) visiblePills++;
    });
    if (visiblePills < 3) pillBar.style.display = 'none';
    pillBar.addEventListener('click', function (e) {
      var pill = e.target.closest('.pill');
      if (!pill) return;
      var keys = (pill.getAttribute('data-keys') || 'all').toLowerCase();
      pillBar.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('on'); });
      pill.classList.add('on');
      cards.forEach(function (card) { card.classList.toggle('hide', !matches(card, keys)); });
    });
  }

  /* Timeline: scroll scrub + arch rotation + clicks */
  var scrub = document.querySelector('.tlscrub');
  if (scrub) {
    var chapters = Array.prototype.slice.call(scrub.querySelectorAll('[data-chapter]'));
    var years = Array.prototype.slice.call(scrub.querySelectorAll('.archyear'));
    var pills = Array.prototype.slice.call(scrub.querySelectorAll('.ypill'));
    var N = chapters.length;
    var current = -1;
    var SPREAD = 72, START = -SPREAD / 2, R = 620, CX = 420, CY = 650;

    /* Years sit fixed on the arc, evenly spread and upright. The active
       chapter is highlighted; nothing rotates (rotation clipped early years). */
    years.forEach(function (btn, i) {
      /* N === 1 would make SPREAD/(N-1) Infinity and the coordinates NaN.
         Chapters are theme-editor blocks, so a one-chapter timeline is reachable. */
      var a = N > 1 ? START + i * (SPREAD / (N - 1)) : 0;
      var rad = a * Math.PI / 180;
      var x = CX + R * Math.sin(rad), y = CY - R * Math.cos(rad);
      btn.style.left = x.toFixed(1) + 'px';
      btn.style.top = y.toFixed(1) + 'px';
      btn.style.transform = 'translate(-50%,-50%)';
    });

    /* Preload a chapter's image so scrubbing to it doesn't wait on a lazy fetch.
       Warming the neighbors of the active chapter keeps the swap instant without
       eager-loading all ten on page load. */
    var warm = function (i) {
      if (i < 0 || i >= N) return;
      var im = chapters[i] && chapters[i].querySelector('img.rimg');
      if (!im) return;
      var s = im.getAttribute('src') || im.currentSrc;
      if (s) { var pre = new Image(); pre.src = s; }
    };

    var setChap = function (idx) {
      if (idx === current || idx < 0 || idx >= N) return;
      current = idx;
      chapters.forEach(function (c, i) { c.classList.toggle('chap-hide', i !== idx); });
      years.forEach(function (b, i) { b.classList.toggle('on', i === idx); });
      pills.forEach(function (b, i) { b.classList.toggle('on', i === idx); });
      warm(idx + 1); warm(idx - 1);
    };
    setChap(0);
    warm(0); warm(1);

    years.concat(pills).forEach(function (btn) {
      btn.addEventListener('click', function () { setChap(parseInt(btn.getAttribute('data-idx'), 10)); });
    });
    var prev = scrub.querySelector('.arrprev'), next = scrub.querySelector('.arrnext');
    if (prev) prev.addEventListener('click', function () { setChap((current + N - 1) % N); });
    if (next) next.addEventListener('click', function () { setChap((current + 1) % N); });

    var mobileTl = window.matchMedia('(max-width: 768px)');
    var onTl = function () {
      if (mobileTl.matches) return;
      var r = scrub.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) return;
      var p = Math.min(Math.max(-r.top / total, 0), 0.999);
      setChap(Math.floor(p * N));
    };
    window.addEventListener('scroll', onTl, { passive: true });
  }

  /* Collection intro: mobile See more / See less (full text stays in the DOM for SEO) */
  var colIntro = document.querySelector('[data-colintro]');
  var colMore = document.querySelector('[data-colmore]');
  if (colIntro && colMore) {
    var colMq = window.matchMedia('(max-width: 768px)');
    var syncIntro = function () {
      if (colMq.matches) {
        if (!colIntro.classList.contains('clamped') && colMore.textContent !== 'See less') {
          colIntro.classList.add('clamped');
        }
        var truncated = colIntro.scrollHeight - colIntro.clientHeight > 4;
        if (colIntro.classList.contains('clamped') && !truncated) {
          colIntro.classList.remove('clamped');
          colMore.hidden = true;
        } else {
          colMore.hidden = false;
        }
      } else {
        colIntro.classList.remove('clamped');
        colMore.hidden = true;
        colMore.textContent = 'See more';
      }
    };
    colMore.addEventListener('click', function () {
      var nowClamped = colIntro.classList.toggle('clamped');
      colMore.textContent = nowClamped ? 'See more' : 'See less';
    });
    syncIntro();
    if (colMq.addEventListener) colMq.addEventListener('change', syncIntro);
  }

  /* Cart qty +/- (posts the form).
     Each click is a full page POST, so a second click landing before the first
     navigation completes used to be silently lost. Lock the form on submit and
     disable the controls so the count the customer sees is the count they get. */
  document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.getAttribute('data-qty-change'));
      if (!input) return;
      var form = input.closest('form');
      if (!form || form.getAttribute('data-submitting') === '1') return;
      var v = parseInt(input.value, 10) || 0;
      v += btn.getAttribute('data-dir') === 'up' ? 1 : -1;
      input.value = Math.max(v, 0);
      form.setAttribute('data-submitting', '1');
      document.querySelectorAll('[data-qty-change]').forEach(function (b) { b.disabled = true; });
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });

  /* Booksy widget fallback. The <noscript> path only covers JS being disabled;
     the common failure is JS enabled with the widget blocked by an ad/tracker
     blocker, or booksy.com being down. The button ships visible and is hidden
     only once the widget has actually put something in the container. */
  var bwrap = document.querySelector('[data-booksy-wrap]');
  var bfall = document.querySelector('[data-booksy-fallback]');
  if (bwrap && bfall) {
    var syncBooksy = function () {
      bfall.hidden = !!bwrap.querySelector('iframe, div, button, a');
    };
    syncBooksy();
    setTimeout(syncBooksy, 1200);
    setTimeout(syncBooksy, 3500);
  }

  /* Judge.me review widget fallback. Same failure shape as Booksy: the widget is
     mounted client-side by the Judge.me app embed, so a disabled embed, an ad
     blocker, or a Judge.me outage leaves an empty container with no error. The
     fallback line ships visible and is hidden only once Judge.me has actually
     rendered its widget root. Judge.me draws its own "no reviews yet" state, so
     if this line is showing, the widget did not load. */
  var jwrap = document.getElementById('judgeme_product_reviews');
  var jfall = document.querySelector('[data-jdgm-fallback]');
  if (jwrap && jfall) {
    var syncJdgm = function () {
      /* Deliberately class-name agnostic. Judge.me's rendered class names differ
         between widget versions, so measure the container instead: if Judge.me
         has put anything of height into it, it mounted. */
      jfall.hidden = jwrap.getBoundingClientRect().height > 20;
    };
    syncJdgm();
    setTimeout(syncJdgm, 1200);
    setTimeout(syncJdgm, 3500);
  }

})();
